import React, {Component} from "react";
import {Moment} from "moment";
// @ts-ignore
import DateTimePicker from "react-datetime-picker";
import {DeliveryStatus} from "../../../constants/DeliveryStatus";
import {IconContext} from "react-icons";
import {ImTruck} from "react-icons/all";
import {DeliveryProgress} from "../../components/DeliveryProgressBar";
import {RequestPayload} from "../types/RequestPayload";
import {ReadAtDatabaseService} from "../../../services/database/ReadAtDatabaseService";
import {UpdateAtDatabaseService} from "../../../services/database/UpdateAtDatabaseService";

const moment = require("moment");

/**
 * Selectable stati for the progress of the delivery
 */
const PossibleStati: { [key: string]: { id: string; name: string } } = {
  active: {
    id: "active",
    name: "In der Zustellung",
  },
  delivered: {
    id: "delivered",
    name: "Zugestellt",
  },
  canceled: {
    id: "canceled",
    name: "Storniert",
  },
  dropAllowed: {
    id: "dropAllowed",
    name: "Abstellgenehmigung erteil",
  },
};

/**
 * Local interface to define the types of the state
 */
interface IState {
  searchResult?: RequestPayload;
  trackingID?: string;

  selectedStatus?: DeliveryStatus;
  chosenETA?: Moment;
  deliveryProgress?: DeliveryProgress;
}

/**
 * Cross Innovation Class 2021
 *
 * Team: Kühne + Nagel
 *
 * Kunden Web App
 *
 * This class is used to update data of a delivery
 *
 * @author Tobias Ramm <winf103614@fh-wedel,de>
 * @version last modification: 29.06.2021
 *
 */
export default class UpdateDelivery extends Component<any> {
  state: Readonly<IState> = {};

  /**
   * Will be called when the user presses search
   */
  async handleSubmit() {
    const { trackingID } = this.state;

    if (trackingID) {
      const delivery: RequestPayload | null = await ReadAtDatabaseService.getDeliveryByTrackingID(
        trackingID
      );

      if (delivery) {
        this.setState({
          searchResult: delivery,
          selectedStatus: delivery.status,
          chosenETA: moment(delivery.estimatedTimeOfArrival),
          deliveryProgress: delivery.deliveryProgress,
        });
      }
    }
  }

  /**
   * Handles the update of a delivery
   */
  async handleUpdate() {
    const {
      trackingID,
      chosenETA,
      selectedStatus,
      deliveryProgress,
    } = this.state;
    if (trackingID) {
      await UpdateAtDatabaseService.updateDelivery(
        trackingID,
        selectedStatus as DeliveryStatus,
        chosenETA as Moment,
        deliveryProgress as DeliveryProgress
      );
    }
  }

  render() {
    return (
      <div className={"createNewRouteContainer"}>
        <div className={"contentBox"}>
          <h1>Zustellung aktualisieren</h1>

          <div className={"trackingInputContainer"}>
            <div className={"trackingInput"}>
              <IconContext.Provider
                value={{ color: "#003369", className: "truckIcon" }}
              >
                <ImTruck />
              </IconContext.Provider>
              <input
                type={"text"}
                placeholder={"Tracking- Nummer eingeben"}
                value={this.state.trackingID}
                onChange={(evt) =>
                  this.setState({ trackingID: evt.target.value })
                }
              />
            </div>
            <button onClick={() => this.handleSubmit()}>Suchen</button>
          </div>

          {!!this.state.searchResult && (
            <div>
              <select
                value={this.state.selectedStatus}
                onChange={(evt) =>
                  this.setState({ selectedStatus: evt.target.value })
                }
              >
                {Object.keys(PossibleStati).map((key: string) => (
                  <option key={key} value={key}>
                    {PossibleStati[key].name}
                  </option>
                ))}
              </select>

              <DateTimePicker
                onChange={(value: Date) =>
                  this.setState({ chosenETA: moment(value) })
                }
                value={this.state.chosenETA && this.state.chosenETA.toDate()}
                clearIcon={null}
                calendarAriaLabel={"Estimated Time of Arrival:"}
                className={"input"}
              />

              <label>
                Zustellstand:
                <select
                  name="deliveryProgress"
                  id="deliveryProgress"
                  onChange={(evt) => {
                    this.setState({ deliveryProgress: evt.target.value });
                  }}
                  value={this.state.deliveryProgress}
                >
                  <option value={DeliveryProgress.CAPTURE}>Erfassung</option>
                  <option value={DeliveryProgress.ON_WAY}>Unterwegs</option>
                  <option value={DeliveryProgress.AT_DELIVERY}>
                    In Zustellung
                  </option>
                  <option value={DeliveryProgress.DELIVERED}>Zugestellt</option>
                </select>
              </label>

              <button onClick={() => this.handleUpdate()}>Aktualisieren</button>
            </div>
          )}
        </div>
      </div>
    );
  }
}
